import React from 'react';
import './style.css';
import {CalendarOutlined, QuestionCircleOutlined} from '@ant-design/icons';
import moment from 'moment';
import {useNavigate} from 'react-router-dom';
import {Button, Popconfirm} from 'antd';
import {useDispatch} from 'react-redux';
import JobsFormComponent from '../../JobsForm';
import view_more_svg from '../../../../../Assets/view-more-right-arrow.svg';
import useLocalization from '../../../../../Localization';
import {
  deleteJobsById,
  editStatusById,
  getJobsByUserId,
} from '../../../../../Store/Actions';
import {getLocalStorageUserInfo} from '../../../../../Util/commonUtility';
import AdJobReceipt from '../../../../CommonComponents/receiptComponent/AdJobReceipt';

const CommonJobsListingCard = (props) => {
  const {
    jobLocation,
    jobEmployer,
    jobTitle,
    jobId,
    jobStatus,
    jobFeesOptions,
    jobFees,
    is_paid,
    months,
    created_at,
    payment,
    onDeleteSuccess,
    showDeactivateButton = true,
  } = props;
  const {ApplicationString} = useLocalization();
  const navigate = useNavigate();
  const [editModalOpen, setEditModalOpen] = React.useState(false);
  const dispatch = useDispatch();
  const [isDeleting, setIsDeleting] = React.useState(false);
  const viewDetailsJob = () => {
    window.open(`/jobs/${jobId}`, '_blank');
  };

  const isJobPayable = jobStatus === 'draft' && jobFees > 0 && !is_paid;
  const isJobEditable =
    jobStatus === 'draft' || (jobStatus === 'in_review' && jobFees > 0);
  const isJobDeactivatable = jobStatus === 'approved' && showDeactivateButton;
  const isDeletable = jobStatus === 'draft';

  const handleDeactivateJob = () => {
    dispatch(editStatusById(jobId, 'deactivate')).then(() => {
      if (onDeleteSuccess) {
        onDeleteSuccess();
      } else {
        const userInfo = getLocalStorageUserInfo();
        const userId = userInfo ? userInfo.id : '';
        dispatch(
          getJobsByUserId(userId, '', '', () => {}, undefined, undefined, ''),
        );
      }
    });
  };

  const handleDeleteJob = () => {
    if (isDeleting) {
      return;
    }
    setIsDeleting(true);
    dispatch(deleteJobsById(jobId))
      .then((deleted) => {
        if (!deleted) {
          return;
        }
        if (onDeleteSuccess) {
          onDeleteSuccess();
        } else {
          const userInfo = getLocalStorageUserInfo();
          const userId = userInfo ? userInfo.id : '';
          dispatch(
            getJobsByUserId(userId, '', '', () => {}, undefined, undefined, ''),
          );
        }
      })
      .finally(() => {
        setIsDeleting(false);
      });
  };

  return (
    <React.Fragment>
      <div className='common-job-listing-card-container'>
        <div className='common-job-listing-card'>
          <div className='common-job-listing-card-content-wrapper'>
            <div className='common-job-listing-locationDateDetails'>
              <div>
                {' '}
                <span className='common-job-listing-locationText'>
                  {jobLocation ? jobLocation : 'N/A'}
                </span>
              </div>

              <div>
                <span className='common-job-listing-dateText'>
                  <span className='dateText-text'>Posted on</span>
                  {`   `}
                  <span className='dateText-date'>
                    <CalendarOutlined />
                    {` `}
                    {created_at
                      ? `${moment(created_at)
                          .utcOffset(0)
                          .format('YYYY-MM-DD')}`
                      : 'N/A'}
                  </span>
                </span>
              </div>
            </div>
            <div className='common-job-left-right-group-wrapper'>
              <div className='common-job-listing-cardLeftGroup '>
                <div
                  className='common-job-listing-card-titleEmployerDetails hyperlink'
                  onClick={viewDetailsJob}>
                  <span className='titleEmployerDetails-employer'>
                    {jobEmployer}
                  </span>
                  <span className='titleEmployerDetails-title'>{`${jobTitle}`}</span>
                </div>
                {
                  <JobsFormComponent
                    isModalOpen={editModalOpen}
                    setIsModalOpen={setEditModalOpen}
                    editData={props}
                    jobFeesOptions={jobFeesOptions}
                  />
                }
              </div>
              <div className='common-job-listing-cardRightGroup'>
                {is_paid && payment && (
                  <div className='common-job-listing-card-download-button-container'>
                    <AdJobReceipt
                      type='job'
                      item={{...props, id: jobId, job_fee: jobFees}}
                    />
                  </div>
                )}
                <div className='common-job-listing-card-action-container'>
                  {isJobPayable && (
                    <Button
                      className='common-ads-listing-card-button'
                      onClick={() => navigate(`/jobs/cart/${jobId}`)}>
                      <span className='link-no-style'>
                        {
                          ApplicationString[
                            'userApprovedJobsListingComponent.button.pay'
                          ]
                        }
                      </span>
                    </Button>
                  )}
                  {isJobEditable && (
                    <Button
                      className='common-ads-listing-card-button'
                      onClick={() => setEditModalOpen(!editModalOpen)}>
                      {
                        ApplicationString[
                          'userApprovedJobsListingComponent.button.edit'
                        ]
                      }
                    </Button>
                  )}
                  {isDeletable && (
                    <Popconfirm
                      title={ApplicationString[
                        'adminActionsDropdownComponent.deleteConfirmTitle'
                      ]('job')}
                      description={
                        ApplicationString[
                          'adminActionsDropdownComponent.deleteConfirmDescription'
                        ]
                      }
                      onConfirm={handleDeleteJob}
                      okText={
                        ApplicationString[
                          'adminActionsDropdownComponent.deleteConfirmOkText'
                        ]
                      }
                      cancelText={
                        ApplicationString[
                          'adminActionsDropdownComponent.deleteConfirmCancelText'
                        ]
                      }
                      okType='danger'
                      icon={
                        <QuestionCircleOutlined
                          style={{
                            color: 'red',
                          }}
                        />
                      }>
                      <Button
                        id={`common-job-listing-deleteButton_${jobId}`}
                        className='common-ads-listing-card-button'
                        disabled={isDeleting}>
                        {
                          ApplicationString[
                            'userApprovedJobsListingComponent.button.delete'
                          ]
                        }
                      </Button>
                    </Popconfirm>
                  )}
                  {isJobDeactivatable && (
                    <Popconfirm
                      title='Deactivate this job?'
                      description='This job will be hidden from active listings.'
                      onConfirm={handleDeactivateJob}
                      okText='Yes'
                      cancelText='No'
                      okType='primary'
                      icon={
                        <QuestionCircleOutlined
                          style={{
                            color: '#faad14',
                          }}
                        />
                      }>
                      <Button className='common-ads-listing-card-button'>
                        Deactivate
                      </Button>
                    </Popconfirm>
                  )}
                </div>

                <Button
                  className='view-more-svg-button'
                  id={`common-job-listing-viewDetailsButton_${jobId}`}
                  onClick={viewDetailsJob}>
                  {
                    ApplicationString[
                      'userApprovedJobsListingComponent.button.viewDetails'
                    ]
                  }
                  <img
                    src={view_more_svg}
                    alt='view_more_svg'
                    className='view-more-svg'
                  />
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default CommonJobsListingCard;
